module.exports = "<div class=\"expense-graph\">\n  <canvas class=\"chart\" #barChart>{{ chart }}</canvas>\n</div>"